const WebGLTest2 = {
  title: 'webGLTest2',
  defaultMaterial: 'MeshPhongMaterial',
  commonModels: ['/assets/exterior.glb'],
  backgroundModel: '/assets/background.glb',
  cubeMap: '/assets/StdSky_IEM/',
  refCubeMap: '/assets/20200827_refCubemap/',
  dirLightIntensity: 1,
  subDirLightIntensity: 0.2,
  ambientLightIntensity: 0.4,
  envIntensity: 0.4,
  initialViewName: 'exterior',
  views: {
    floor1: {
      models: ['/assets/floor1.glb'],
      initCameraPos:{
        x: 27, y: 21, z: -18
    },
      initCameraAngle: {
        azimuth: 1.88,
        polar: 1.37,
      }
    },
    floor2: {
      models: ['/assets/floor2.glb'],
      initCameraPos:{
        x: 9, y: 50, z: 24
      },
      initCameraAngle: {
        azimuth: -0.13295846971394495,
        polar: 1.28,
      }
    },
    exterior: {
      models: [],
      initCameraPos:{
        x: -135, y: 88, z: 171
      },
      initCameraAngle: {
        azimuth: -0.68,
        polar :1.36,
      }
    }
  }
}

const P3DDemo = {
  title: 'P3DDemo',
  defaultMaterial: 'MeshPhongMaterial',
  commonModels: ['/assets/P3DDemo_exterior.glb'],
  backgroundModel: '/assets/background.glb',
  cubeMap: '/assets/StdSky_IEM/',
  refCubeMap: '/assets/20200827_refCubemap/',
  dirLightIntensity: 1,
  subDirLightIntensity: 0.2,
  ambientLightIntensity: 0.4,
  envIntensity: 0.4,
  initialViewName: 'exterior',
  views: {
    floor1: {
      models: ['/assets/P3DDemo_floor1.glb'],
      initCameraPos:{
        x: -28, y: 21, z: 37
    },
      initCameraAngle: {
        azimuth: 5.18,
        polar: 1.4,
      }
    },
    floor2: {
      models: ['/assets/P3DDemo_floor2.glb'],
      initCameraPos:{
        x: 9, y: 50, z: 24
      },
      initCameraAngle: {
        azimuth: 1.8,
        polar: 1.31,
      }
    },
    exterior: {
      models: [],
      initCameraPos:{
        x: -135, y: 88, z: 171
      },
      initCameraAngle: {
        azimuth: -0.68,
        polar :1.36,
      }
    }
  }
}

const P3DDemo_merged = {
  title: 'P3DDemo_merged',
  defaultMaterial: 'MeshPhongMaterial',
  commonModels: ['/assets/P3DDemo_exterior_merged.glb'],
  backgroundModel: '/assets/background.glb',
  cubeMap: '/assets/StdSky_IEM/',
  refCubeMap: '/assets/20200827_refCubemap/',
  dirLightIntensity: 1,
  subDirLightIntensity: 0.2,
  ambientLightIntensity: 0.4,
  envIntensity: 0.4,
  initialViewName: 'exterior',
  views: {
    floor1: {
      models: ['/assets/P3DDemo_floor1_merged.glb'],
      initCameraPos:{
        x: -28, y: 21, z: 37
    },
      initCameraAngle: {
        azimuth: 5.18,
        polar: 1.4,
      }
    },
    floor2: {
      models: ['/assets/P3DDemo_floor2_merged.glb'],
      initCameraPos:{
        x: 9, y: 50, z: 24
      },
      initCameraAngle: {
        azimuth: 1.8,
        polar: 1.31,
      }
    },
    exterior: {
      models: [],
      initCameraPos:{
        x: -135, y: 88, z: 171
      },
      initCameraAngle: {
        azimuth: -0.68,
        polar :1.36,
      }
    }
  }
}


const PL002 = {
  title: 'PL002',
  defaultMaterial: 'MeshPhongMaterial',
  commonModels: ['/assets/PL002_exterior.glb'],
  backgroundModel: '/assets/background.glb',
  cubeMap: '/assets/StdSky_IEM/',
  refCubeMap: '/assets/20200827_refCubemap/',
  dirLightIntensity: 1,
  subDirLightIntensity: 0.2,
  ambientLightIntensity: 0.4,
  envIntensity: 0.4,
  initialViewName: 'exterior',
  views: {
    floor1: {
      models: ['/assets/PL002_floor1.glb'],
      initCameraPos:{
        x: 17, y: 21, z: 19
      }, 
      initCameraAngle: {
        azimuth: 5.86,
        polar: 1.45,
      }
    },
    floor2: {
      models: ['/assets/PL002_floor2.glb'],
      initCameraPos:{
        x: -26, y: 54, z: 18.8
      },
      initCameraAngle: {
        azimuth: -1.01,
        polar: 1.28,
      }
    },
    floor3: {
      models: ['/assets/PL002_floor3.glb'],
      initCameraPos:{
        x: -37, y: 80, z: 16
    },
      initCameraAngle: {
        azimuth: -1.14,
        polar: 1.46,
      }
    },
    exterior: {
      models: [],
      initCameraPos:{
        x: -135, y: 88, z: 171
      },
      initCameraAngle: {
        azimuth: -0.68,
        polar :1.36,
      }
    }
  }
}


const PL002_merged = {
  title: 'PL002_merged',
  defaultMaterial: 'MeshPhongMaterial',
  commonModels: ['/assets/PL002_exterior_merged.glb'],
  backgroundModel: '/assets/background.glb',
  cubeMap: '/assets/StdSky_IEM/',
  refCubeMap: '/assets/20200827_refCubemap/',
  dirLightIntensity: 1,
  subDirLightIntensity: 0.2,
  ambientLightIntensity: 0.4,
  envIntensity: 0.4,
  initialViewName: 'exterior',
  views: {
    floor1: {
      models: ['/assets/PL002_floor1_merged.glb'],
      initCameraPos:{
        x: 17, y: 21, z: 19
      }, 
      initCameraAngle: {
        azimuth: 5.86,
        polar: 1.45,
      }
    },
    floor2: {
      models: ['/assets/PL002_floor2_merged.glb'],
      initCameraPos:{
        x: -26, y: 54, z: 18.8
      },
      initCameraAngle: {
        azimuth: -1.01,
        polar: 1.28,
      }
    },
    floor3: {
      models: ['/assets/PL002_floor3_merged.glb'],
      initCameraPos:{
        x: -37, y: 80, z: 16
    },
      initCameraAngle: {
        azimuth: -1.14,
        polar: 1.46,
      }
    },
    exterior: {
      models: [],
      initCameraPos:{
        x: -135, y: 88, z: 171
      },
      initCameraAngle: {
        azimuth: -0.68,
        polar :1.36,
      }
    }
  }
}

export default {
  WebGLTest2: WebGLTest2,
  PL002: PL002,
  PL002_merged: PL002_merged,
  P3DDemo: P3DDemo,
  P3DDemo_merged: P3DDemo_merged,
}
